import { render, staticRenderFns } from "./Friend.vue?vue&type=template&id=7a02f1c8&scoped=true"
import script from "./Friend.vue?vue&type=script&lang=js"
export * from "./Friend.vue?vue&type=script&lang=js"
import style0 from "./Friend.vue?vue&type=style&index=0&id=7a02f1c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a02f1c8",
  null
  
)

export default component.exports